import axios from './axios'
import { Kardias,File } from '@../../../EshJSLib/models/patient';

export async function getKardias() {
    const response = await axios.get(`/api/getKardiaFile`);
    return response.data.data as File[];
}

export async function updateKardia(params) {
    const response = await axios.put(`/api/kardias/${params.id_file}`,params);
    return response.data;
}

export async function deleteKardia(id: number) {
    const response = await axios.delete(`/api/kardias/${id}`);
    return response.data;
}

export async function anteprimaKardia(id: Number) {
    const response = await axios.get(`/api/anteprimaKardia/${id}`);
    return response.data;
}

export async function getKardia(id: Number) {
    const response = await axios.get(`/api/kardias/getKardia/${id}`);
return response.data.data as File;
}


export async function previewKardia(id: Number)   {
    axios.get(`/api/anteprimaKardia/${id}`, { responseType: 'blob' })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: response.data.type }));
      window.open(url, '_blank');
    })
    .catch(error => {
      console.error('Error preveiwing PDF:', error);
    });
  }